import React from 'react'
import styles from './ArticleHeader.module.scss'
import Author from 'components/author/Author'
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from 'react-share'
import { ArticleHeaderProps } from '../types'
import Tag from 'components/tag/Tag'
import { Heading } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next'

const ArticleHeader = ({ author, messageShareText, tag, tagColor, title }: ArticleHeaderProps) => {
  const url = typeof window !== 'undefined' ? window.location.href : ''

  //i18n
  const { t } = useTranslation('blog')

  return (
    <section className={styles['article-header']}>
      <Tag transparentBackground={!tagColor} color={tagColor}>
        {tag}
      </Tag>
      <Heading as="h1" variant="h2">
        {title}
      </Heading>
      <div className={styles['meta-container']}>
        <Author {...author} />

        <div className={styles['socials-container']}>
          <FacebookShareButton className={styles['button-share']} resetButtonStyle={false} url={url}>
            <FacebookIcon size={20} bgStyle={{ fill: 'none' }} />
            {t('share.share')}
          </FacebookShareButton>
          <EmailShareButton className={styles['button-share']} resetButtonStyle={false} url={url} body={messageShareText || title}>
            <EmailIcon size={20} bgStyle={{ fill: 'none' }} />
            {t('share.mail')}
          </EmailShareButton>
          <TwitterShareButton className={styles['button-share']} resetButtonStyle={false} url={url} title={messageShareText || title}>
            <TwitterIcon size={20} bgStyle={{ fill: 'none' }} />
            {t('share.tweet')}
          </TwitterShareButton>
          <WhatsappShareButton className={styles['button-share']} resetButtonStyle={false} url={url} title={messageShareText || title}>
            <WhatsappIcon size={20} bgStyle={{ fill: 'none' }} />
            {t('share.app')}
          </WhatsappShareButton>
        </div>
      </div>
    </section>
  )
}

export default ArticleHeader
